var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisbursement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003641",
    clipPath: "url(#clip0_18_1014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 125",
    d: "M5.76578 17.3765H1.52002V22.2288H7.58539C8.19193 22.2288 8.79847 22.8353 10.0115 23.4419C11.2246 24.0484 13.0933 23.6808 13.6508 23.4419C17.8965 21.6223 19.1096 21.0157 22.7488 19.1961C25.4613 17.8399 23.4482 15.2072 21.5358 16.1634C20.9933 16.4347 15.4063 18.9249 14.8638 19.1961C13.6508 19.8026 13.0442 19.8026 12.4377 19.1961C11.9525 18.7109 11.2246 18.5896 8.19193 18.5896C10.0115 18.5896 12.6214 18.3261 13.6508 17.983C15.4704 17.3765 14.8638 15.5569 13.6508 15.5569L8.19193 15.5569C7.33416 15.5569 6.37232 17.3765 5.76578 17.3765Z",
    stroke: "#AD2120",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1270",
    d: "M11.5 4V9H15.5V4",
    stroke: "#AD2120",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M12.2545 4.63922H9.97363L13.6506 1L17.3275 4.63922H14.7499",
    stroke: "#AD2120",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1271",
    d: "M4.55273 17.983V16.77V9.49152C4.55273 8.82155 5.09585 8.27844 5.76581 8.27844H11.8312M15.4704 8.27844H21.5358C22.2057 8.27844 22.7489 8.82155 22.7489 9.49152V15.5569",
    stroke: "#AD2120",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 513",
    cx: 14,
    cy: 12,
    r: 1.5,
    stroke: "#AD2120"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisbursement);
export default __webpack_public_path__ + "static/media/Disbursement.92dc019eaca2cf0a572343ab7727ece2.svg";
export { ForwardRef as ReactComponent };